module.exports = __webpack_public_path__ + "img/p2.7ad42251.png";